module.exports = __webpack_public_path__ + "static/media/Born Again - Instrumental Version.5414fdde.jpg";